export default __webpack_public_path__ + "add0b9a8db0b3b34a70cccd6804864b2.svg";